// The existing backend supplies the official general CPI levels. No extra service request.
export const CPI_SOURCE = 'https://veriportali.tuik.gov.tr/tr/databrowser/tuik/categories/6/6_5/TR,DF_TUFE_SDMX_TT09,1.0';
export const RENT_LAW_SOURCE = 'https://mevzuat.adalet.gov.tr/mevzuat/103273';
export const shiftMonth = (period, offset) => {
 const [year,month]=period.split('-').map(Number),value=year*12+month-1+offset;
 return `${Math.floor(value/12)}-${String((value%12)+1).padStart(2,'0')}`;
};
export const rentPercent = value => value==null?'—':`%${new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(value)}`;
export function rentRenewalRates(observations) {
 const points=new Map(),conflicts=new Set();
 for(const row of observations||[]) {
  if(row.indicator!=='cpi'||row.scope!=='TR'||row.source!=='TÜİK'||!/^\d{4}-(0[1-9]|1[0-2])$/.test(row.period)||!Number.isFinite(row.value)||row.value<=0)continue;
  if(points.has(row.period)&&points.get(row.period).value!==row.value)conflicts.add(row.period);
  points.set(row.period,row);
 }
 const result=[];
 for(const period of [...points.keys()].sort()) {
  const months=Array.from({length:24},(_,index)=>shiftMonth(period,index-23));
  if(months.some(month=>!points.has(month)||conflicts.has(month)))continue;
  const levels=months.map(month=>points.get(month).value),previous=levels.slice(0,12).reduce((a,b)=>a+b,0),current=levels.slice(12).reduce((a,b)=>a+b,0);
  const rate=Number(((current/previous-1)*100).toFixed(2));
  result.push({period:shiftMonth(period,1),cpiPeriod:period,rate,sourceUrl:CPI_SOURCE,lastSuccessfulCheckAt:points.get(period).last_successful_check_at});
 }
 return result;
}
